"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureConditionalDisplay = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const alchemy_ui_1 = require("@m/alchemy-ui");
const types_1 = require("./types");
const react_string_replace_1 = __importDefault(require("react-string-replace"));
const VerticalStack_1 = __importDefault(require("@mdigital/components/dist/components/VerticalStack"));
const modals_1 = require("@mdigital/components/dist/utils/modals");
const conversions_1 = require("./conversions");
const operators_1 = require("./operators");
const ConditionalDisplayCondition_1 = require("./Condition/ConditionalDisplayCondition");
const ConditionBuilder_1 = require("./ConditionBuilder");
const ConditionBuilderSyntax_1 = require("./ConditionBuilderSyntax");
const utils_1 = require("../../../common/utils");
const react_final_form_1 = require("react-final-form");
const final_form_arrays_1 = __importDefault(require("final-form-arrays"));
const state_1 = require("./ConditionBuilder/state");
const conditionalDisplayConditionSyntax_1 = require("./Condition/conditionalDisplayConditionSyntax");
const styled_components_1 = __importDefault(require("styled-components"));
const SyntaxBox_1 = __importDefault(require("./SyntaxBox"));
const TextPathPrefix = `app.pages.forms.builder.tabs.fieldSettings.conditionalDisplayModal`;
const ModalTitleText = `${TextPathPrefix}.title`;
const DescriptionText = `${TextPathPrefix}.multiconditionDescription`;
const AddConditionText = `${TextPathPrefix}.addCondition`;
const AddGroupText = `${TextPathPrefix}.addGroup`;
const AddText = `${TextPathPrefix}.add`;
const AndOperatorText = `${TextPathPrefix}.andOperator`;
const OrOperatorText = `${TextPathPrefix}.orOperator`;
const AutoOpenScreenCaptureText = `${TextPathPrefix}.openScAuto`;
const ConditionSyntaxText = `${TextPathPrefix}.conditionSyntax`;
const OperationCommentText = `${TextPathPrefix}.operationSelectorComment`;
const DeleteItemText = `${TextPathPrefix}.deleteItem`;
const DeleteGroupText = `${TextPathPrefix}.deleteGroup`;
const CancelText = `${TextPathPrefix}.cancel`;
const SaveText = `${TextPathPrefix}.save`;
const builderConfiguration = {
    labels: {
        addItem: (0, utils_1.getSingleText)(AddConditionText),
        operationSelectorComment: (0, utils_1.getSingleText)(OperationCommentText),
        addGroup: (0, utils_1.getSingleText)(AddGroupText),
        add: (0, utils_1.getSingleText)(AddText),
        deleteItem: (0, utils_1.getSingleText)(DeleteItemText),
        deleteGroup: (0, utils_1.getSingleText)(DeleteGroupText),
    },
    allowEmptyGroup: true,
    operators: [
        { label: (0, utils_1.getSingleText)(AndOperatorText), value: 'and' },
        { label: (0, utils_1.getSingleText)(OrOperatorText), value: 'or' }
    ],
    defaultOperator: 'and',
    levels: 4,
};
const flattenBuilderState = (state) => {
    return [].concat(...state.conditions.map(item => (0, state_1.isGroup)(item) ? flattenBuilderState(item) : [item]));
};
const allowAutoOpen = (state) => {
    const conditions = flattenBuilderState(state);
    return conditions.some(item => item.type === 'component' && (item.operator != null && item.operator !== operators_1.operators.hasNoValue));
};
const Body = styled_components_1.default.div `
  margin-right: ${(0, alchemy_ui_1.units)(1)};
`;
const renderConditionalBuilderSyntax = (props) => {
    return (0, ConditionBuilderSyntax_1.renderSyntax)({
        state: props.state,
        renderCondition: (item) => (0, conditionalDisplayConditionSyntax_1.renderConditionSyntax)(item, props.components),
    });
};
const ConditionalBuilderModal = (props) => {
    const [initialState] = (0, react_1.useState)(Object.assign(Object.assign({}, (0, conversions_1.convertToBuilderState)(props.component.cdSource)), { autoOpenScreenCapture: (0, conversions_1.convertAutoOpenScreenCapture)(props.component.cdSource) }));
    const description = (0, react_string_replace_1.default)((0, utils_1.getSingleText)(DescriptionText), ':component:', (match, index) => (React.createElement(react_1.Fragment, { key: index }, props.component.unique_name)));
    const renderItem = (0, react_1.useMemo)(() => (parent) => (React.createElement(ConditionalDisplayCondition_1.ConditionLine, { disabled: props.isFormPublished, parent: parent, components: props.availableComponents, customParams: props.customParams })), [props.availableComponents, props.customParams]);
    const body = (React.createElement(Body, null,
        React.createElement(VerticalStack_1.default, { gap: 'large' },
            React.createElement(VerticalStack_1.default, { gap: 'small' },
                React.createElement("div", null,
                    React.createElement(ConditionBuilder_1.Builder, { isReadOnly: props.isFormPublished, configuration: builderConfiguration, renderItem: renderItem, createItem: ConditionalDisplayCondition_1.createItem })),
                props.component.component === types_1.FormComponents.SCREEN_CAPTURE &&
                    React.createElement(react_final_form_1.FormSpy, { render: ({ values }) => (React.createElement(react_final_form_1.Field, { name: 'autoOpenScreenCapture', render: ({ input }) => (React.createElement(alchemy_ui_1.Field, { disabled: !allowAutoOpen(values), input: React.createElement(alchemy_ui_1.Checkbox, { disabled: props.isFormPublished, label: (0, utils_1.getSingleText)(AutoOpenScreenCaptureText), checked: input.value, onChange: (event) => input.onChange(event.target.checked) }) })) })) })),
            React.createElement(react_final_form_1.FormSpy, { render: ({ values }) => {
                    const syntax = values == undefined ? '' : renderConditionalBuilderSyntax({
                        state: values,
                        components: props.availableComponents,
                    });
                    return (React.createElement(alchemy_ui_1.Field, { label: (0, utils_1.getSingleText)(ConditionSyntaxText), isFullWidth: true, disabled: props.isFormPublished, input: (React.createElement(SyntaxBox_1.default, { text: syntax })) }));
                } }))));
    const onSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        const formula = Object.assign({}, values);
        const filteredConditions = (0, conversions_1.withoutEmptyConditions)(formula.conditions);
        const resultFormula = filteredConditions.length === 0 ? undefined : Object.assign(Object.assign({}, formula), { conditions: filteredConditions });
        if (resultFormula != null && !allowAutoOpen(resultFormula)) {
            formula.autoOpenScreenCapture = undefined;
        }
        props.onSubmit(resultFormula);
        return Promise.resolve();
    });
    return (React.createElement(react_final_form_1.Form, { mutators: Object.assign({}, final_form_arrays_1.default), onSubmit: onSubmit, initialValues: initialState, render: ({ handleSubmit }) => props.render({
            size: 'extraLarge',
            close: {
                title: (0, utils_1.getSingleText)(CancelText)
            },
            submit: {
                callback: (context) => {
                    var _a;
                    (_a = handleSubmit()) === null || _a === void 0 ? void 0 : _a.then(() => context.close());
                },
                title: (0, utils_1.getSingleText)(SaveText),
                shouldAutoClose: false,
            },
            body: body,
            title: (0, utils_1.getSingleText)(ModalTitleText),
            description: React.createElement(React.Fragment, null, description)
        }) }));
};
const configureConditionalDisplay = (props) => {
    modals_1.ModalsService.showCustomModal(ConditionalBuilderModal, {
        customParams: props.customParams,
        isFormPublished: props.isFormPublished,
        availableComponents: props.availableComponents,
        component: props.component,
        onSubmit: (conditionalDisplay) => {
            props.onSubmit(conditionalDisplay);
        },
    });
};
exports.configureConditionalDisplay = configureConditionalDisplay;
